/**
 * Safely resolves a value that may be an array, a JSON-encoded array string,
 * or malformed/empty input into an array. Never throws.
 *
 * Useful when hydrating data that an API may send in inconsistent shapes
 * (e.g. an already-parsed array vs. a JSON string vs. null).
 */
export const safeParseArray = <TItem = unknown>(value: unknown): TItem[] => {
  if (Array.isArray(value)) {
    return value as TItem[];
  }
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value || '[]');
      return Array.isArray(parsed) ? (parsed as TItem[]) : [];
    } catch {
      return [];
    }
  }
  return [];
};
